import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

function load (component) {
  return require(`@/${component}.vue`)
}

function loadView (component) {
  return require(`views/${component}.vue`)
}

const router = new VueRouter({
  /*
   * NOTE! VueRouter "history" mode DOESN'T works for Cordova builds,
   * it is only to be used only for websites.
   *
   * If you decide to go with "history" mode, please also open /config/index.js
   * and set "build.publicPath" to something other than an empty string.
   * Example: '/' instead of current ''
   *
   * If switching back to default "hash" mode, don't forget to set the
   * build publicPath back to '' so Cordova builds work again.
   */

  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      component: loadView('MainView'),
      meta: {
        auth: true,
      },
      children: [
        {
          path: '',
          component: loadView('UsersView'),
        },
        {
          path: 'users',
          component: loadView('UsersView'),
        },
        {
          path: 'users/:id',
          component: loadView('UserView'),
          children: [
            {
              path: '',
              component: loadView('UserDetailsView'),
            },
            {
              path: 'transactions',
              component: loadView('UserTransactionsView'),
            },
            {
              path: 'tokens',
              component: loadView('UserTokensView'),
            },
          ],
        },
        {
          path: 'projects',
          component: loadView('ProjectsView'),
        },
        {
          path: 'projects/:id',
          component: loadView('ProjectView'),
          children: [
            {
              path: '',
              component: loadView('ProjectDetailsView'),
            },
            {
              path: 'metrics',
              component: loadView('ProjectMetricsView'),
            },
            {
              path: 'daily-metrics',
              component: loadView('ProjectDailyMetricsView'),
            },
            {
              path: 'bills',
              component: loadView('ProjectBillsView'),
            },
            {
              path: 'transactions',
              component: loadView('ProjectTransactionsView'),
            },
            {
              path: 'services',
              component: loadView('ProjectServicesView'),
            },
            {
              path: 'documents',
              component: loadView('ProjectDocumentsView'),
            },
            {
              path: 'logs',
              component: loadView('ProjectLogsView'),
            },
            {
              path: 'acts',
              component: loadView('ProjectActsView'),
            },
            {
              path: 'requisites',
              component: loadView('ProjectRequisitesView'),
            },
            {
              path: 'payment-methods',
              component: loadView('ProjectPaymentMethodsView'),
            },
          ],
        },
        {
          path: 'tags',
          component: loadView('TagsView'),
        },
        {
          path: 'versions',
          component: loadView('VersionsView'),
        },
        {
          path: 'bills',
          component: loadView('BillsView'),
        },
        {
          path: 'logs',
          component: loadView('LogsView'),
        },
        {
          path: 'logs/:id',
          component: loadView('LogsView'),
        },
        {
          path: 'service-providers',
          component: loadView('ServiceProvidersView'),
          meta: {
            auth: ['root', 'manager'],
          },
        },
        {
          path: 'project-configs',
          component: loadView('McpProjectConfigsView'),
          meta: {
            auth: ['root', 'manager'],
          },
        },
      ],

    },
    {
      path: '/invoice/:id',
      meta: {
        auth: undefined,
      },
      component: loadView('Invoice/InvoiceView'),
    },
    {
      path: '/bill/:id/privat24',
      meta: {
        auth: undefined,
      },
      component: loadView('Privat24View'),
    },
    {
      path: '/stripe/:id/success',
      meta: {
        auth: undefined,
      },
      component: loadView('Stripe/SuccessResponse'),
    },
    {
      path: '/stripe/:id/error',
      meta: {
        auth: undefined,
      },
      component: loadView('Stripe/ErrorResponse'),
    },
    {
      path: '/act',
      name: 'act',
      component: loadView('ActView'),
      props: (route) => ({
        ...route.params,
      }),
    },
    {
      path: '/start-pay-act',
      name: 'start-pay-act',
      component: loadView('ActStartPayView'),
      props: route => ({
        ...route.params,
      }),
    },
    {
      path: '/welcome',
      meta: {
        auth: false,
      },
      component: loadView('LoginView'),
    },
    {
      path: '*',
      component: loadView('Error404View'),
    }, // Not found
  ],
})

router.beforeEach((to, from, next) => {
  if (to.path === '/welcome' && from.path === '/' &&
    localStorage.getItem('default_auth_token')) {
    next({ path: '/' })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./resources/assets/js/router.js